export default "__VITE_ASSET__T3AfBAKp__"